import { useTranslation } from 'react-i18next';
import { useTier } from '../hooks/useTier';
import { UpgradeButton } from './UpgradeButton';

export function ReadOnlyBanner() {
  const { t } = useTranslation();
  const { isReadOnly, monetizationEnabled } = useTier();

  if (!monetizationEnabled || !isReadOnly) return null;

  return (
    <div className="read-only-banner">
      <span>{t('app.readOnlyBanner.message')}</span>
      <UpgradeButton />
    </div>
  );
}
